import { render, staticRenderFns } from "./CompanyMachineDetails.vue?vue&type=template&id=5372a880"
import script from "./CompanyMachineDetails.vue?vue&type=script&lang=js"
export * from "./CompanyMachineDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports